import { IModel } from "@/@types/models/model";
import { coreFields } from "@/models/helpers/coreFields";
import { commonFields } from "./helpers/commonFields";

const ObilaznicaPointModel: IModel = {
  title: "Obilaznice",
  apiPath: "obilaznice/{obilaznica_id}/points",
  httpUpdateVerb: "put",
  forms: {
    "default": {
      fields: ["poi_id", "is_obvezna", "sortorder", "group_order", "group_name", "group_name_en"]
    },
  },
  listViews: {
    "default": {
      fields: ["id", "sortorder", "poi_naziv", "is_obvezna", "group_name"],
      // fields: ["id", "poi_id", "is_obvezna", "sortorder", "group_name"],
      hidden: ["id"]
    }
  },
  fields: [
    coreFields.id,
    {
      title: "Obilaznica ID",
      source: "obilaznica_id",
      ttoken: "obilaznice.obilaznica",
      type: "picker",
      submodel: {
        api: "obilaznice?needFor=picker",
        label: "{naziv}"
      },
      filter: true,
      readonly: true
    },
    {
      title: "POI ID",
      source: "poi_id",
      ttoken: "obilaznice.checkpoint",
      type: "picker",
      subModel: {
        apiPath: "poi?need_for=picker",
        format: "{label}"
      },
      filter: true,
      validation: {
        required: true
      },
      tooltip: "obilaznice.pick_poi"
    },
    {
      title: "POI Naziv", // Only used in list view (table). So that its possible to use filters on this column. Poi_id is still used in forms.
      source: "poi_naziv",
      ttoken: "obilaznice.checkpoint",
      type: "text",
      filter: true
    },
    {
      title: "Obvezna",
      source: "is_obvezna",
      ttoken: "obilaznice.point_obvezna",
      type: "boolean",
      items: {
        labels: ["common.ne", "common.da"],
        values: [false, true],
        default: true
      },
      translate: true,
      filter: true,
      validation: {
        required: true
      }
    },
    {
      title: "SortOrder",
      source: "sortorder",
      ttoken: "obilaznice.sortorder",
      type: "wholenum",
      validation: {
        required: true
      }
    },
    {
      title: "Group Order",
      source: "group_order",
      ttoken: "obilaznice.group_order",
      type: "wholenum"
    },
    {
      title: "Group Name",
      source: "group_name",
      ttoken: "obilaznice.group_name",
      type: "text",
      filter: true
    },
    {
      title: "Group Name EN",
      source: "group_name_en",
      ttoken: "obilaznice.group_name_en",
      type: "text",
      filter: true
    },
    {
      title: "Active",
      source: "active",
      ttoken: "obilaznice.active",
      type: "boolean"
     },
    coreFields.modified_on,
    coreFields.created_on
  ]
}

export default ObilaznicaPointModel;
